import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchProductCategoryList = createAsyncThunk("fetchProductCategoryList", async ({ page, limit, filters }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const params = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: filters?.keyword ?? "",
		company: filters?.company ?? "",
	});

	const response = await axiosHttp.get(`/productcategory/list?${params}`, config);
	return response.data.data;
});

const ProductListSlice = createSlice({
	name: "ProductListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchProductCategoryList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchProductCategoryList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.current_page;
			state.total = action.payload.total;
		});
		builder.addCase(fetchProductCategoryList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ProductListSlice.reducer;
